module.exports = __webpack_public_path__ + "img/goodthings24_oztix_600x300_lineup_onsalenow.457d2dfe.gif";